import cx from '../../../../utils/cx';

import Typography, { FONT_TYPES } from '../Typography/Typography';

import styles from './RadioButton.module.scss';

const RadioButton = ({ id, name, className, children, ...rest }) => {
  return (
    <>
      <input type="radio" id={id} name={name} className={styles.input} {...rest} />
      <label htmlFor={id} className={cx(styles.label, className)}>
        <Typography type={FONT_TYPES.body_semibold} htmlTag="span" isCenter>
          {children}
        </Typography>
      </label>
    </>
  );
};

export default RadioButton;
